import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { DialogService } from "src/app/Shared/dialog.service";
import { QuickLoanService } from "../services/quickLoan.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
declare var $: any;
@Component({
  selector: "app-quickloan-lending-conditions",
  templateUrl: "./quickloan-lending-conditions.component.html",
  styleUrls: ["./quickloan-lending-conditions.component.scss"],
})
export class QuickloanLendingConditionsComponent implements OnInit {
  showSpinner: boolean = false;
  Value: any = "Add";
  BtnValue: any = "Save";
  loading: boolean = false;
  Headers: any = [];
  Id: any = 0;
  stepEMI: any[] = [];
  stepEMIProposed: any[] = [];
  stepEMIApproved: any[] = [];
  stepEmiDataApproved: any;
  minLoanMaturityDate: any;
  Name: any = "Months";
  emiIrrdataApproved: any;
  emiIrr: any;
  stepEmiData: any;
  stepEmiDataProposed: any;
  selectedScheme: any = {};
  LoanDetail: any = {};
  LoanDetailApproved: any = {};
  isCalEMITableView: boolean = true;
  stepEmiForm: boolean = true;
  isFrequency: boolean = false;

  LendingConditionsDetails: any = [];
  LendingConditionsData: any;
  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;
  @Input() Status: any;
  @Input() ProcessName: any;
  Header: string;
  currentUser: any;
  emiIrrProposed: any;
  cEIModel: any = {
    Asset_Cost: 0,
    IRR_Type: "Flat",
    EMI_Type: "Monthly",
    ProductId: "",
    IRR_CalculateBy: "ROI",
    Adv_Inst:0
  };
  FrequenctDropDownList: any;
  Vehicle_Type: any;
  IRR_CalculateByDropDownList:any;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private _Route: Router,
    private activedRoute: ActivatedRoute,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
     private MasterService: MasterService,
    // private LmsService: LmsService,
    private DecriptService: EncrDecrService,
    private dialog: DialogService,
    private _QuickLoanService: QuickLoanService,
    private _EncrDecrService: EncrDecrService,
    private route: ActivatedRoute,
    private LmsService: LmsService
  ) {}

  ngOnInit(): void {
    // console.log("input loan summary", this.loanSummary);
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.GetFrequenctDropDown();
    this.GetIRR_CalculateByDropDown();
    this.LmsService.LMS_GetLoanDetails({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
      // console.log("LMS_GetLoanDetails", res);
      this.Vehicle_Type = res.Item6.length > 0 ? res.Item6[0].Vehicle_Type : "";
      // console.log("this.Vehicle_Type", this.Vehicle_Type);
    });

    this.GetLendingConditions();
    this.getLoanAccount();
  }
  GetFrequenctDropDown() {
    this.MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "EMI FREQUENCY" })
      .subscribe((res: any) => {
        console.log(res);
        this.FrequenctDropDownList = res;

      });

  }
      GetIRR_CalculateByDropDown() {
      this.MasterService
        .GetCommonMaster_FOR_DROPDOWN({ Type: "IRR_CalculateBy" })
        .subscribe((res: any) => {
          console.log(res);
          this.IRR_CalculateByDropDownList = res;

        });
    
  }
  addLendingConditions() {
    this.BtnValue = "Save";
    this.Id = 0;
    this.Header = "";
    this.LendingConditionsDetails = [];
    this.initializeDetail();
    $("#lendingConditions").modal("show");
    $("#lendingConditions").css("z-index", "1050");
  }

  initializeDetail() {
    this.LendingConditionsDetails.push({
      Detail: "",
    });
  }

  addMoreData() {
    this.initializeDetail();
  }

  removeData(index: any) {
    this.LendingConditionsDetails.splice(index, 1);
  }

  onCloseLendingConditions() {
    $("#lendingConditions").modal("hide");
  }
  OnSaveLendingConditions() {
    this.onCloseLendingConditions();
    this.showSpinner = true;
    var Details = { Data: this.LendingConditionsDetails };
    this._QuickLoanService
      .QuickLoan_Save_Lender_Conditions({
        JSON: JSON.stringify(Details),
        Header: this.Header,
        Loan_Id: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        Id: this.Id,
      })
      .subscribe((response: any) => {
        //console.log(response);
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.GetLendingConditions();
          this.QuickLoan_Save_PageProcess("Lending Conditions");
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
        this.showSpinner = false;
      });
  }

  QuickLoan_Save_PageProcess(PageType) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: this.PageData.MM_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }

  GetLendingConditions() {
    this.Headers = [];
    this._QuickLoanService
      .QuickLoan_Get_Lender_Conditions({
        Loan_Id: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.LendingConditionsData = res;
          this.LendingConditionsData.forEach((obj: any) => {
            if (
              this.Headers &&
              this.Headers.find((result) => result.Id === obj.Id)
            ) {
              this.Headers.find(
                (result) => result.Id === obj.Id
              ).Condition.push({ Detail: obj.Detail });
            } else {
              this.Headers.push({
                Id: obj.Id,
                Header: obj.Particulars,
                Condition: [{ Detail: obj.Detail }],
              });
            }
          });
        }
      });
  }

  OnEditLendingConditions(vdData) {
    this.Header = "";
    this.LendingConditionsDetails = [];
    this.BtnValue = "Edit";
    this.Id = vdData.Id;
    this.Header = vdData.Header;
    vdData.Condition.forEach((obj: any) => {
      this.LendingConditionsDetails.push({
        Detail: obj.Detail,
      });
    });
    $("#lendingConditions").modal("show");
    $("#lendingConditions").css("z-index", "1050");
  }

  OnDeleteLendingConditions(Id) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Delete Lending Conditions.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this._QuickLoanService
            .QuickLoan_Delete_Lender_Conditions({
              Loan_Id: this.loanSummary.LoanId,
              Id: Id,
            })
            .subscribe((response: any) => {
              // console.log(response);
              if (response[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
                this.GetLendingConditions();
                this.QuickLoan_Save_PageProcess("Lending Conditions");
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }

  getLoanAccount() {
    this.stepEMI = [];
    // this.showSpinner = true;
    this._QuickLoanService
      .QuickLoan_Get_Financial_Proposed_And_Lender({
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        // isCalEMITableView
        if (res.Item1.length > 0) {
          this.LoanDetail = res.Item1[0];
          this.cEIModel.ProcessingFee = this.LoanDetail.ProcessingFeePercentage;
          let dataProposed = {
            Disbursement_Amt: res.Item1[0].DisbursementAmt,
            Interest_Amt: res.Item1[0].InterestAmt,
            Agreement_Value: res.Item1[0].AgreementValue,
            LTV: res.Item1[0].LTV,
            ROI: res.Item1[0].Flat_Rate,
            EMI_Amt: res.Item1[0].Application_LoanEMIAmount,
            Case_IRR: res.Item1[0].Case_IRR,
            Disbursement_IRR: res.Item1[0].Disbursement_IRR,
            Margin: res.Item1[0].Margin,
          };
          this.emiIrrProposed = dataProposed;
          if (
            this.LoanDetail.EMI_Type == "Daily" ||
            this.LoanDetail.EMI_Type == "Weekly" ||
            this.LoanDetail.EMI_Type == "Fortnightly" ||
            this.LoanDetail.EMI_Type == "ByWeekly" ||
            this.LoanDetail.EMI_Type == "FourthWeekly" ||
            this.LoanDetail.EMI_Type == "SingleEMI"
          ) {
            this.LoanDetail.Name = "Days";
            this.Name = "Days";
          } else {
            this.LoanDetail.Name = "Months";
            this.Name = "Months";
          }
          //this.isCalEMITableView = false;
          //this.isCalEMIForm = true;
          this.stepEMIProposed = [];
          if (
            res.Item1[0].Application_IRR_CalculateBy == "ROI" ||
            res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
          ) {
            // this.cEIModel.IsStep = true;
            this.stepEMIProposed.push({
              FromEMI: 1,
              ToEMI: res.Item1[0].No_Of_Instl,
              EMI_Amount: this.emiIrrProposed.EMI_Amt.toFixed(2),
              NoOfInstl: res.Item1[0].No_Of_Instl,
              TotalAmount: this.emiIrrProposed.Agreement_Value.toFixed(2),
              disable: true,
            });
          }
          if (res.Item1[0].Application_IRR_CalculateBy == "STEP_EMI") {
            this.stepEMIProposed = [];
            this._QuickLoanService
              .QuickLoan_Get_StepEMI({
                LoanId: this.loanSummary.LoanId,
                Id: res.Item1[0].RestructureId,
              })
              .subscribe((res: any) => {
                this.stepEMIProposed = res;

                for (let i = 0; i < res.length; i++) {
                  this.stepEMIProposed[i].EMI_Amount = res[i].EMIAmount;
                  this.stepEMIProposed[i].NoOfInstl = res[i].NoOfEMI;
                }
                // this.getTotlaEmiAndAmountProposed();
              });
          }
          if (res.Item1[0].Application_IRR_CalculateBy == "FLAT_EMI") {
            this.stepEMIProposed.push({
              FromEMI: 1,
              ToEMI: res.Item1[0].No_Of_Instl,
              EMI_Amount: this.emiIrrProposed.EMI_Amt.toFixed(2),
              NoOfInstl: res.Item1[0].No_Of_Instl,
              TotalAmount: this.emiIrrProposed.Agreement_Value.toFixed(2),
              disable: true,
            });
            // document.getElementById("CalculateByEMI")['checked'] = true;
          }

          if (res.Item2.length > 0) {
            this.LoanDetailApproved = res.Item2.filter(x => x.Type =='Lender')[0];
            let dataApproved = {
              Disbursement_Amt: res.Item2[0].DisbursementAmt,
              Interest_Amt: res.Item2[0].InterestAmt,
              Agreement_Value: res.Item2[0].AgreementValue,
              LTV: res.Item2[0].LTV,
              ROI: res.Item2[0].Flat_Rate,
              EMI_Amt: res.Item2[0].Application_LoanEMIAmount,
              Case_IRR: res.Item2[0].Case_IRR,
              Disbursement_IRR: res.Item2[0].Disbursement_IRR,
              Margin: res.Item2[0].Margin,
            };
            if (this.LoanDetailApproved != undefined) {
              if (res.Item2[0].Type == "Sanction") {
                this.LoanDetailApproved.Heading = "Recommended";
              } else {
                this.LoanDetailApproved.Heading = "Lender";
              }
              this.emiIrrdataApproved = dataApproved;
              if (
                this.LoanDetailApproved.EMI_Type == "Daily" ||
                this.LoanDetailApproved.EMI_Type == "Weekly" ||
                this.LoanDetailApproved.EMI_Type == "Fortnightly" ||
                this.LoanDetailApproved.EMI_Type == "ByWeekly" ||
                this.LoanDetailApproved.EMI_Type == "FourthWeekly" ||
                this.LoanDetailApproved.EMI_Type == "SingleEMI"
              ) {
                this.LoanDetailApproved.Name = "Days";
                this.Name = "Days";

                //
              } else {
                this.LoanDetailApproved.Name = "Months";
                this.Name = "Months";
              }

              //this.isCalEMITableView = false;
              //this.isCalEMIForm = true;
              this.stepEMIApproved = [];
              if (
                res.Item2[0].Application_IRR_CalculateBy == "ROI" ||
                res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
              ) {
                // this.cEIModel.IsStep = true;
                this.stepEMIApproved.push({
                  FromEMI: 1,
                  ToEMI: res.Item2[0].No_Of_Instl,
                  EMI_Amount: this.emiIrrdataApproved.EMI_Amt.toFixed(2),
                  NoOfInstl: res.Item2[0].No_Of_Instl,
                  TotalAmount: this.emiIrrdataApproved.Agreement_Value.toFixed(2),
                  disable: true,
                });
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "STEP_EMI") {
                this.stepEMIApproved = [];
                this._QuickLoanService
                  .QuickLoan_Get_StepEMI({
                    LoanId: this.loanSummary.LoanId,
                    Id: res.Item2[0].RestructureId,
                  })
                  .subscribe((res: any) => {
                    this.stepEMIApproved = res;

                    for (let i = 0; i < res.length; i++) {
                      this.stepEMIApproved[i].EMI_Amount = res[i].EMIAmount;
                      this.stepEMIApproved[i].NoOfInstl = res[i].NoOfEMI;
                    }
                    // this.getTotlaEmiAndAmountApproved();
                  });
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "FLAT_EMI") {
                this.stepEMIApproved.push({
                  FromEMI: 1,
                  ToEMI: res.Item2[0].No_Of_Instl,
                  EMI_Amount: this.emiIrrdataApproved.EMI_Amt.toFixed(2),
                  NoOfInstl: res.Item2[0].No_Of_Instl,
                  TotalAmount: this.emiIrrdataApproved.Agreement_Value.toFixed(2),
                  disable: true,
                });
                // document.getElementById("CalculateByEMI")['checked'] = true;
              }
            }
            if (res.Item2[0].Application_IRR_CalculateBy) {
              this.cEIModel.Asset_Cost = res.Item2[0].AssetCost
                ? res.Item2[0].AssetCost == -1 || res.Item2[0].AssetCost == 0
                  ? 0
                  : res.Item2[0].AssetCost
                : 0;
              this.cEIModel.NetFinance_Amt = res.Item2[0].NetFinance;
              this.cEIModel.IRR_CalculateBy =
                res.Item2[0].Application_IRR_CalculateBy;
              this.cEIModel.EMI_Type = res.Item2[0].EMI_Type;
              this.cEIModel.No_Of_Inst = res.Item2[0].No_Of_Instl;
              this.cEIModel.Tenure = res.Item2[0].Tenure;
              this.cEIModel.Adv_Inst = res.Item2[0].Adv_Instl;
              this.cEIModel.MgmtFee = res.Item2[0].ManagementFee;
              this.cEIModel.First_EMI_Date = new Date(
                res.Item2[0].FirstEMIDate
              );
              this.cEIModel.Flat_Rate = res.Item2[0].Flat_Rate;
              this.cEIModel.EMI_Amount = res.Item2[0].Application_LoanEMIAmount;
              this.cEIModel.IRR_CalculateBy =
                res.Item2[0].Application_IRR_CalculateBy;
              this.cEIModel.Reducing_ROI = res.Item2[0].Case_IRR;
              this.cEIModel.Loan_Date = new Date(res.Item2[0].Loan_Date);
              this.cEIModel.LoanMaturityDate = new Date(
                res.Item2[0].LoanMaturityDate
              );
              this.cEIModel.ROI_Input_mathod = res.Item2[0].ROI_Input_mathod;

              if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI")
                this.isFrequency = true;
              $(function () {
                $("#Flat_Rate").val(res.Item2[0].Flat_Rate);
              });

              $(function () {
                $("#EMI_Amounts").val(res.Item2[0].Application_LoanEMIAmount);
              });

              let data = {
                Disbursement_Amt: res.Item2[0].DisbursementAmt,
                Interest_Amt: res.Item2[0].InterestAmt,
                Agreement_Value: res.Item2[0].AgreementValue,
                LTV: res.Item2[0].LTV,
                ROI: res.Item2[0].Flat_Rate,
                EMI_Amt: res.Item2[0].Application_LoanEMIAmount,
                Case_IRR: res.Item2[0].Case_IRR,
                Disbursement_IRR: res.Item2[0].Disbursement_IRR,
                Margin: res.Item2[0].Margin,
              };
              this.stepEMI = [];
              this.emiIrr = data;
              if (
                res.Item2[0].Application_IRR_CalculateBy == "ROI" ||
                res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
              ) {
                // this.cEIModel.IsStep = true;
                this.stepEMI.push({
                  FromEMI: 1,
                  ToEMI: this.cEIModel.No_Of_Inst,
                  EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
                  NoOfInstl: this.cEIModel.No_Of_Inst,
                  TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
                  disable: true,
                });
                // document.getElementById("CalculateByFlat")['checked'] = true;
                //var amt = this.emiIrr.ROI.toFixed(2);
                //$(function () {
                //  $("#Flat_Rate").val(amt);
                //});
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "STEP_EMI") {
                let stepArr: any[] = [];
                this.cEIModel.IsStep = true;
                this._QuickLoanService
                  .QuickLoan_Get_StepEMI({
                    LoanId: this.loanSummary.LoanId,
                    Id: res.Item2[0].RestructureId,
                  })
                  .subscribe((res: any) => {
                    this.stepEMI = res;

                    for (let i = 0; i < res.length; i++) {
                      this.stepEMI[i].EMI_Amount = res[i].EMIAmount;
                      this.stepEMI[i].NoOfInstl = res[i].NoOfEMI;
                      for (
                        let j = +this.stepEMI[i].FromEMI;
                        j <= +this.stepEMI[i].ToEMI;
                        j++
                      ) {
                        if (+this.stepEMI[i].EMI_Amount >= 0) {
                          stepArr.push(this.stepEMI[i].EMI_Amount);
                        }
                      }
                    }
                    // this.getTotlaEmiAndAmount();
                  });
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "FLAT_EMI") {
                this.stepEMI.push({
                  FromEMI: 1,
                  ToEMI: this.cEIModel.No_Of_Inst,
                  EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
                  NoOfInstl: this.cEIModel.No_Of_Inst,
                  TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
                  disable: true,
                });
                // document.getElementById("CalculateByEMI")['checked'] = true;
              }
            }
          }
        }

        this.showSpinner = false;
      });
  }

  addLendingFinancial() {
    $("#loanFinancialDetailsModel").modal("show");
    $("#loanFinancialDetailsModel").css("z-index", "1050");
   
  }

  onCloseLoanFinancialDetails() {
    $("#loanFinancialDetailsModel").modal("hide");
  }

  onCalculateEmiAndIRR() {
    let netAmount: any[] = [];
    let roi: any[] = [];

    if (+this.cEIModel.NetFinance_Amt <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Net Finance Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.Flat_Rate < 0 &&
      this.cEIModel.IRR_CalculateBy == "ROI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Flat rate should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.EMI_Amount <= 0 &&
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.No_Of_Inst <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.Tenure <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Tenure should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI" &&
      +this.cEIModel.EMI_Amount * +this.cEIModel.No_Of_Inst <
        +this.cEIModel.NetFinance_Amt
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment multiply by EMI amount should be greater than or equal to Net Finance Amount.",
        ...this.configSuccess,
      });
      return;
    }

    if (this.cEIModel.EMI_Type == "SingleEMI") {
      var ROI = parseFloat(this.cEIModel.Flat_Rate);
      if (this.cEIModel.ROI_Input_mathod == "Daily") {
        ROI = ROI * this.currentUser.DaysInYear;
      }
      var Interest_Amt = Math.round(
        ((parseFloat(this.cEIModel.NetFinance_Amt) * ROI) /
          100 /
          this.currentUser.DaysInYear) *
          this.cEIModel.Tenure
      );
      var Agreement_Value = Math.round(
        parseFloat(this.cEIModel.NetFinance_Amt) +
          parseFloat(Interest_Amt.toString())
      );

      let data = {
        Disbursement_Amt: this.cEIModel.NetFinance_Amt,
        Interest_Amt: Interest_Amt,
        Agreement_Value: Agreement_Value,
        ROI: parseFloat(this.cEIModel.Flat_Rate),
        EMI_Amt: Agreement_Value,
        Case_IRR: parseFloat(this.cEIModel.Flat_Rate),
        Disbursement_IRR: parseFloat(this.cEIModel.Flat_Rate),
        Margin: 0,
      };
      this.emiIrr = data;

      if (this.cEIModel.IRR_CalculateBy == "ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.EMI_Amt.toFixed(2);
        $(function () {
          $("#EMI_Amounts").val(amt);
        });
      }

      if (this.cEIModel.IRR_CalculateBy == "FLAT_EMI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.ROI.toFixed(2);
        $(function () {
          $("#Flat_Rate").val(amt);
        });
      }
    } else {
      if (this.selectedScheme.Amount) {
        netAmount = this.selectedScheme.Amount.split("-");
        roi = this.selectedScheme.ROI.split("-");
        if (
          +this.cEIModel.NetFinance_Amt > +netAmount[1] ||
          +this.cEIModel.NetFinance_Amt < +netAmount[0]
        ) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Net Finance Amount should be in between Scheme Amount.",
            ...this.configSuccess,
          });
          return;
        }
        if (
          this.cEIModel.IRR_CalculateBy == "ROI" &&
          (+this.cEIModel.Flat_Rate > +roi[1] ||
            +this.cEIModel.Flat_Rate < +roi[0])
        ) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Flate Rate should be in between Scheme ROI.",
            ...this.configSuccess,
          });
          return;
        }
        if (+this.cEIModel.Adv_Inst < +this.selectedScheme.AdvanceEMI) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Advance Installment can not be less than Scheme Advance EMI.",
            ...this.configSuccess,
          });
          return;
        }
        this.calculateEmiIrr();
      } else {
        this.calculateEmiIrr();
      }
    }
  }
  calculateEmiIrr() {
    let stepArr: any[] = [];
    if (this.cEIModel.IRR_CalculateBy == "STEP_EMI") {
      this.cEIModel.IsStep = true;
      if (this.stepEMI.length < 1) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Please add step EMI first",
          ...this.configSuccess,
        });
        return;
      }
      let lastEMI = this.stepEMI[this.stepEMI.length - 1].ToEMI;
      if (+lastEMI != +this.cEIModel.No_Of_Inst) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Should Be Equal To No of Installment",
          ...this.configSuccess,
        });
        return;
      }

      //if (this.stepEmiData == undefined || this.stepEmiData == null) {
      //  this.snackBar.openFromComponent(SnackbarComponent, {
      //    data: "Please recalculate amount.",
      //    ...this.configSuccess,
      //  });
      //  return;
      //}
      if (
        this.stepEmiData != undefined &&
        +this.stepEmiData.totalAmount < +this.cEIModel.NetFinance_Amt
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Amount should be  equal or Greater then  Net Finance Amount.",
          ...this.configSuccess,
        });
        return;
      }
      for (let i = 0; i < this.stepEMI.length; i++) {
        for (
          let j = +this.stepEMI[i].FromEMI;
          j <= +this.stepEMI[i].ToEMI;
          j++
        ) {
          if (+this.stepEMI[i].EMI_Amount >= 0) {
            stepArr.push(this.stepEMI[i].EMI_Amount);
          }
        }
      }
    } else {
      this.cEIModel.IsStep = false;
      this.cEIModel.STEP_IRR = 0;
    }
    let _data = { ...this.cEIModel };
    _data.cashflow = stepArr;
    if (this.cEIModel.IsStep) {
      _data.EMI_Amount = this.stepEmiData.totalAmount;
    }
    // if (this.cEIModel.Adv_Inst > 0) {
    _data.DaysInYear = this.currentUser.DaysInYear;
    //  this.LmsService.LMS_GetCalculateEMIIRR(_data).subscribe((res: any) => {
    //    if (res.length > 0) {
    //      _data.NetFinance_Amt =
    //        this.cEIModel.NetFinance_Amt -
    //        this.cEIModel.Adv_Inst * res[0].EMI_Amt;
    //      _data.No_Of_Inst = this.cEIModel.No_Of_Inst - this.cEIModel.Adv_Inst;
    //      console.log("_data.NetFinance_Amt", _data.NetFinance_Amt);
    //      this.getCalculateEMIIRR(_data);
    //    }
    //  });
    //} else {
    this.getCalculateEMIIRR(_data);
    //}
  }
  getCalculateEMIIRR(data: any) {
    this.showSpinner = true;
    // data.ProductId = 2;
    data.DaysInYear = this.currentUser.DaysInYear;
    this.LmsService.LMS_GetCalculateEMIIRR(data).subscribe((res: any) => {
      this.showSpinner = false;
      this.emiIrr = res[0];
      setTimeout(() => {
        var elmntToView = document.getElementById("scrollto");
        elmntToView.scrollIntoView();
      }, 500);

      if (this.cEIModel.IRR_CalculateBy == "ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      $("#EMI_Amounts").val(this.emiIrr.EMI_Amt.toFixed(2));
      if (this.cEIModel.IRR_CalculateBy == "FLAT_EMI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      $("#Flat_Rate").val(this.emiIrr.ROI.toFixed(2));
    });
  }

  onSaveApplication() {
    if (+this.cEIModel.NetFinance_Amt <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Net Finance Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.Flat_Rate < 0 &&
      this.cEIModel.IRR_CalculateBy == "ROI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Flate rate should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.EMI_Amount <= 0 &&
      this.cEIModel.IRR_CalculateBy == "EMI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.No_Of_Inst <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.Tenure <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Tenure should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.cEIModel.IRR_CalculateBy !== "STEP_EMI" &&
      +this.cEIModel.No_Of_Inst * +this.emiIrr.EMI_Amt <
        +this.cEIModel.NetFinance_Amt
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI multiply with installment should be equal or grater than net finance.",
        ...this.configSuccess,
      });
      return;
    }
    if (this.cEIModel.IRR_Type == "Step") {
      let length = this.stepEMI.length;
      let ToEmi = this.stepEMI[length - 1].ToEMI;
      if (+ToEmi != +this.cEIModel.No_Of_Inst) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Add EMI step.",
          ...this.configSuccess,
        });
        return;
      }
      if (
        this.emiIrr.Disbursement_Amt + this.emiIrr.Interest_Amt !=
        +this.stepEmiData.totalAmount
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Amount must be equal to  (Disbursement Amount  + Interest Amount)",
          ...this.configSuccess,
        });
        return;
      }
    }
    let _stepEmi: any[] = [];
    this.stepEMI.forEach((obj: any) => {
      _stepEmi.push(this.dataSharingService.cleanObject({ ...obj }));
    });

    if (
      this.emiIrr.Interest_Amt == null ||
      this.emiIrr.Interest_Amt == 0 ||
      this.emiIrr.Interest_Amt == ""
    ) {
      this.emiIrr.Interest_Amt = 0;
      this.emiIrr.Case_IRR = 0;
      this.emiIrr.Disbursement_IRR = 0;
    }
    let data = {
      Application: this.dataSharingService.cleanObject({
        LoanId: this.loanSummary.LoanId,
        BranchId: 1,
        ProductId: this.cEIModel.ProductId,
        Asset_Cost: this.cEIModel.Asset_Cost,
        NetFinance_Amt: this.cEIModel.NetFinance_Amt,
        Flat_Rate: this.emiIrr.ROI,
        No_Of_Inst: this.cEIModel.No_Of_Inst,
        Tenure: this.cEIModel.Tenure,
        Adv_Inst: this.cEIModel.Adv_Inst,
        MgmtFee: 0, // this.cEIModel.MgmtFee,
        EMI_Type: this.cEIModel.EMI_Type,
        Disbursement_Amt: this.emiIrr.Disbursement_Amt,
        Interest_Amt: this.emiIrr.Interest_Amt,
        Agreement_Value: this.emiIrr.Agreement_Value,
        LTV: this.emiIrr.LTV,
        EMI_Amt: this.emiIrr.EMI_Amt,
        Case_IRR: this.emiIrr.Case_IRR,
        Disbursement_IRR: this.emiIrr.Disbursement_IRR,
        Loan_Purpose: this.cEIModel.Purpose,
        Loan_SchemeId: this.selectedScheme.SchemeId,
        FirstEMIDate: this.cEIModel.First_EMI_Date,
        IRR_Type: this.cEIModel.IRR_Type,
        LoginUserId: this.currentUser.userId,
        ROI: this.emiIrr.ROI,
        EMI_Amount: this.cEIModel.EMI_Amount,
        IRR_CalculateBy: this.cEIModel.IRR_CalculateBy,
        LoanMaturityDate: this.cEIModel.LoanMaturityDate,
        Loan_Date: this.cEIModel.Loan_Date,
        ProcessingFeePercentage: this.cEIModel.ProcessingFee,
      }),
      StepIRR: _stepEmi,
    };

    this._QuickLoanService
      .QuickLoan_Lender_Financial_Sanction({ JSON: JSON.stringify(data) })
      .subscribe((res: any) => {
        if (res) {
          if (res[0] ? res[0].CODE >= 0 : false) {
            this.getLoanAccount();

            this.QuickLoan_Save_PageProcess("Lending Conditions");

            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
            this.onCloseLoanFinancialDetails();
          } else if (res[0]) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
          }
        }
      });
  }
  setTenure() {
    if (this.cEIModel.No_Of_Inst && this.cEIModel.EMI_Type != "SingleEMI") {
      if (this.cEIModel.EMI_Type == "ByMonthly") {
        this.cEIModel.Tenure = 2 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Quarterly") {
        this.cEIModel.Tenure = 3 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "HalfYearly") {
        this.cEIModel.Tenure = 6 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Yearly") {
        this.cEIModel.Tenure = 12 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Weekly") {
        this.cEIModel.Tenure = 7 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Fortnightly") {
        this.cEIModel.Tenure = 15 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "ByWeekly") {
        this.cEIModel.Tenure = 14 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "FourthWeekly") {
        this.cEIModel.Tenure = 28 * +this.cEIModel.No_Of_Inst;
      } else {
        this.cEIModel.Tenure = this.cEIModel.No_Of_Inst;
      }
      if (
        this.cEIModel.EMI_Type == "Daily" ||
        this.cEIModel.EMI_Type == "Weekly" ||
        this.cEIModel.EMI_Type == "Fortnightly" ||
        this.cEIModel.EMI_Type == "ByWeekly" ||
        this.cEIModel.EMI_Type == "FourthWeekly" ||
        this.cEIModel.EMI_Type == "SingleEMI"
      )
        this.Name = "Days";
      else this.Name = "Months";
    }
    this.setAdvanceInstl();
  }
  setAdvanceInstl() {
    if (Number(this.cEIModel.Adv_Inst) >= Number(this.cEIModel.No_Of_Inst)) {
      this.cEIModel.Adv_Inst = 0;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Advance Installment not greater than No. Of Installment !!!",
        ...this.configSuccess,
      });
    }
  }
}
